
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.755 11.364H9.063c-.787 0-1.427.64-1.427 1.426v5.329c0 .786.64 1.426 1.427 1.426h11.692c.787 0 1.427-.64 1.427-1.426V12.79c0-.786-.64-1.426-1.427-1.426zM9 12.727h11.818l-.028 2.457-1.063-.784c-.579-.435-1.373-.405-1.946.084l-2.77 2.487a.175.175 0 01-.23.003l-1.872-1.552a1.536 1.536 0 00-1.988.005L9 17.067v-4.34z","fill":"#525F7F"}}),_c('path',{attrs:{"d":"M23.09 5H6.728A2.73 2.73 0 004 7.727v14.546A2.73 2.73 0 006.727 25h16.364a2.73 2.73 0 002.727-2.727V7.727A2.73 2.73 0 0023.091 5zm0 18.182H6.728a.91.91 0 01-.909-.91V9.546H24v12.728a.91.91 0 01-.91.909z","fill":"#525F7F"}}),_c('path',{attrs:{"d":"M21.273 22.273H8.545a.91.91 0 010-1.818h12.728a.91.91 0 010 1.818z","fill":"#B4BCCF"}})])
          )
        }
      }
    